var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7295 13.8086L15.6621 2.55393C15.5752 2.47268 15.472 2.40821 15.3584 2.36423C15.2448 2.32025 15.123 2.29761 15 2.29761C14.877 2.29761 14.7552 2.32025 14.6416 2.36423C14.528 2.40821 14.4248 2.47268 14.3379 2.55393L2.27051 13.8086C1.91895 14.1367 1.71973 14.5824 1.71973 15.0473C1.71973 16.0125 2.56055 16.7973 3.59473 16.7973H4.86621V24.8282C4.86621 25.3121 5.28516 25.7032 5.80371 25.7032H13.125V19.5782H16.4062V25.7032H24.1963C24.7148 25.7032 25.1338 25.3121 25.1338 24.8282V16.7973H26.4053C26.9033 16.7973 27.3809 16.6141 27.7324 16.2832C28.4619 15.5996 28.4619 14.4922 27.7295 13.8086V13.8086Z",
    fill: "#7F3DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.af178d25.svg";
export { ForwardRef as ReactComponent };